import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";
import { Reorder } from "framer-motion";

// get customers

export const getCustomers = createAsyncThunk("client/customer-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}admin/customer/api/v1/customer-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response.data.customers", response.data.customers);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

//Update customer
// Update customer
export const updateCustomerApi = createAsyncThunk("client/update-customer", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  const rowId = data.ROWID;

  try {
    const response = await axios.put(`${baseUrl}admin/customer/api/v1/update-customer/${rowId}`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Update customer request:", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error updating customer:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to update customer");
  }
});

// create customer
export const AddCustomerApi = createAsyncThunk("client/create-customer", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/customer/api/v1/create-customer`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("created request of add coustomer ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

//single custtomer delete

export const deleteCustomerApi = createAsyncThunk("client/delete-customer", async (rowId, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/customer/api/v1/delete-customer/${rowId}`, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Deleted request of customer ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

//multiple coustomer delte

export const deleteMultipleCustomersApi = createAsyncThunk("client/delete-multiple-customers", async (rowIds, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/customer/api/v1/delete-customer`, rowIds, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("Deleted request of multiple customers ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

// get customer count

export const getCustomerCount = createAsyncThunk("client/customer-count", async () => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}admin/customer/api/v1/customer-count`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("response.data.customers", response.data.count);
    return response.data.count;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});
